import {CSSProperties} from 'react'

export const stornoColor = '#ff6d02';
